import { InputFilterType } from '@share/common-types';
import { ComponentFunction, IColumnMenu } from '@constants';
import { useIntl } from 'react-intl';
import { CompanyBookingPrice } from '../../components/components/company-refundability';
const getCompanyBookingPrice: ComponentFunction = (text: any, record: any) => <CompanyBookingPrice record={record} />;

const STATUS = 'bookingStatusEnum';
const CATEGORY = 'bookingType';
const PROPERTY_NAME = 'propertyName';
const PROPERTY_CITY = 'propertyCity';
const BOOKING_CODE = 'customerLocator';
const CHECK_IN = 'checkIn';
const CHECK_OUT = 'checkOut';
const CREATED_AT = 'createdAt';
const LEAD_NAME = 'leadName';

const COLUMNS_WIDTH = {
  [PROPERTY_NAME]: { normal: 265, all: 255 },
  [LEAD_NAME]: { normal: 175, all: 165 },
  [PROPERTY_CITY]: { normal: 155, all: 145 },
  [CHECK_IN]: { normal: 135, all: 127 },
  [CHECK_OUT]: { normal: 135, all: 127 },
  [CREATED_AT]: { normal: 135, all: 127 },
  [CATEGORY]: { normal: 130, all: 120 },
  [STATUS]: { normal: 150, all: 120 },
};
export const GetCompanyBookingColumnMenu = (): IColumnMenu[] => {
  const intl = useIntl();
  return [
    {
      description: intl.formatMessage({ id: 'guest.title' }),
      key: LEAD_NAME,
      width: 175,
      display: true,
      order: 1,
      type: InputFilterType.Text,
      displayConditions: false,
    },

    {
      description: intl.formatMessage({ id: 'In' }),
      key: CHECK_IN,
      width: 135,
      incomingDateFormat: 'MM/DD/YYYY',
      display: true,
      order: 2,
      type: InputFilterType.Date,
      displayConditions: true,
    },
    {
      description: intl.formatMessage({ id: 'out' }),
      key: CHECK_OUT,
      width: 135,
      incomingDateFormat: 'MM/DD/YYYY',
      display: true,
      order: 3,
      type: InputFilterType.Date,
      displayConditions: true,
    },

    {
      description: intl.formatMessage({ id: 'hotel.title' }),
      key: PROPERTY_NAME,
      width: 265,
      display: true,
      order: 4,
      type: InputFilterType.Text,
      displayConditions: false,
    },
    {
      description: intl.formatMessage({ id: 'location' }),
      key: PROPERTY_CITY,
      width: 155,
      display: true,
      order: 5,
      type: InputFilterType.Text,
      displayConditions: false,
    },
    {
      description: intl.formatMessage({ id: 'booking.code' }),
      key: BOOKING_CODE,
      width: 155,
      display: true,
      order: 6,
      type: InputFilterType.Text,
      displayConditions: false,
    },
    {
      description: intl.formatMessage({ id: 'created.at' }),
      key: CREATED_AT,
      width: 135,
      incomingDateFormat: 'MM/DD/YYYY HH:mm',
      display: true,
      order: 7,
      type: InputFilterType.Date,
      displayConditions: true,
    },

    {
      description: intl.formatMessage({ id: 'price' }),
      key: 'totalPaid',
      width: 150,
      type: InputFilterType.Custom,
      display: true,
      order: 6,
      component: getCompanyBookingPrice,
    },
  ];
};
